import profile6 from "../assets/profile6.jpg"
import profile2 from "../assets/profile2.jpg"
import profile3 from "../assets/profile3.jpg"
import profile4 from "../assets/profile4.jpg"
import profile5 from "../assets/profile5.jpg"
import background1 from "../assets/bckg1.jpg"
import background2 from "../assets/bckg2.jpg"
import background3 from "../assets/bckg3.jpg"
import background4 from "../assets/bckg4.jpg"
import background5 from "../assets/bckg5.jpg"
  
  const Stories = [
    {
        id: Math.random(),
        profileimg: profile6,
        background: background3,
        storyname: "Sarah Takumi"
    },
    {
        id: Math.random(),
        profileimg: profile2,
        background: background2,
        storyname: "Rukia Aizen"

    },
    {
        id: Math.random(),
        profileimg: profile3,
        background: background1,
        storyname: "Sasuke Uchiha"

    },
    {
        id: Math.random(),
        profileimg: profile4,
        background: background4,
        storyname: "Shinra Tensei"

    },
    {
        id: Math.random(),
        profileimg: profile5,
        background: background5,
        storyname: "Isthar Order"
    },
]

export default Stories;